import React from "react";
import { Routes, Route } from "react-router-dom";
import { authStore } from "@/store/auth";

import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

import PrivateRoute from "@/components/app/PrivateRoute";
import NotFound from "./pages/NotFound";
import Home from "./pages/Home";
import FilmCreate from "./pages/FilmCreate";
import SerialCreate from "./pages/SerialCreate";
import Login from "@/pages/Login";
import Import from "@/pages/Import";
import CreateContent from "@/pages/CreateContent";
import FiilmView from "@/pages/FiilmView";
import SerialSeries from '@/pages/SerialSeries'
import Serie from '@/pages/Serie'
import Order from '@/pages/Order'
import SerialSeason from "./pages/SerialSeason";
import SerialView from "./pages/SerialView";
import Adtag from "./pages/Adtag";
import StudioDomains from "./pages/StudioDomains";
import Docs from "./pages/Docs";

import "antd/dist/reset.css";

function App() {
  return (
    <div className="app">
      {authStore.isLoading && <Spin indicator={<LoadingOutlined />} />}

      {!authStore.isLoading && (
        <div className="app__container">
          <Routes>
            <Route path="/login" element={<Login />} />

            <Route
              path="/"
              element={
                <PrivateRoute>
                  <Home />
                </PrivateRoute>
              }
            />

            <Route
              path="/create-content"
              element={
                <PrivateRoute>
                  <CreateContent />
                </PrivateRoute>
              }
            />
            <Route
              path="/film-create"
              element={
                <PrivateRoute>
                  <FilmCreate />
                </PrivateRoute>
              }
            />
            <Route
              path="/films/:id"
              element={
                <PrivateRoute>
                  <FilmCreate />
                </PrivateRoute>
              }
            />
            <Route
              path="/film-view/:id"
              element={
                <PrivateRoute>
                  <FiilmView />
                </PrivateRoute>
              }
            />
            <Route
              path="/serial-view/:id"
              element={
                <PrivateRoute>
                  <SerialView />
                </PrivateRoute>
              }
            />

            <Route
              path="/serial/:id"
              element={
                <PrivateRoute>
                  <SerialCreate />
                </PrivateRoute>
              }
            />
            <Route
              path="/serial/:id/seasons/"
              element={
                <PrivateRoute>
                  <SerialSeason />
                </PrivateRoute>
              }
            />
            <Route
              path="/serial/:id/series/"
              element={
                <PrivateRoute>
                  <SerialSeries />
                </PrivateRoute>
              }
            />
            <Route
              path="/serial/:id/order/"
              element={
                <PrivateRoute>
                  <Order />
                </PrivateRoute>
              }
            />
            <Route
              path="/serial/:id/series/:id"
              element={
                <PrivateRoute>
                  <Serie />
                </PrivateRoute>
              }
            />

            <Route
              path="/import"
              element={
                <PrivateRoute>
                  <Import />
                </PrivateRoute>
              }
            />

            <Route
                path="/adtag"
                element={
                  <PrivateRoute>
                    <Adtag />
                  </PrivateRoute>
                }
            />

            <Route
                path="/studio/domains"
                element={
                  <PrivateRoute>
                    <StudioDomains />
                  </PrivateRoute>
                }
            />

            <Route
                path="/docs"
                element={
                  <PrivateRoute>
                    <Docs />
                  </PrivateRoute>
                }
            />

            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
      )}
    </div>
  );
}

export default App;
